import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LoaderOverlay from "../loading_page/loading_page";
import _ from "lodash";

function ReviseChargePage() {
  const navigate = useNavigate();
  const [cookie, setCookie] = useCookies(["admin"]);
  const [isLoading, setIsLoading] = useState(false);
  const [chargeInfo, setChargeInfo] = useState<any>({});
  const [first, setFirst] = useState<number>();
  const [second, setSecond] = useState<number>();
  const [third, setThird] = useState<number>();
  const [fourth, setFourth] = useState<number>();
  const [fifth, setFifth] = useState<number>();
  const [normal, setNormal] = useState<number>();
  const [reduce, setReduce] = useState<number>();
  const [medical, setMedical] = useState<number>();
  const [basic, setBasic] = useState<number>();
  const [M30, setM30] = useState<number>();
  const [M60, setM60] = useState<number>();
  const [M90, setM90] = useState<number>();
  const [M120, setM120] = useState<number>();
  const [M150, setM150] = useState<number>();
  const [M180, setM180] = useState<number>();
  const [M210, setM210] = useState<number>();
  const [M240, setM240] = useState<number>();

  useEffect(() => {
    const getChargeAPI = process.env.REACT_APP_SERVER_URI + "/charge";
    axios
      .get(getChargeAPI, {
        headers: {
          "Content-Type": "application/json",
          Authorization: cookie.admin,
        },
      })
      .then((res) => {
        const info = res.data.foundCharge;
        if (info === null) {
          return;
        }

        setChargeInfo(info);
        setFirst(info.first);
        setSecond(info.second);
        setThird(info.third);
        setFourth(info.fourth);
        setFifth(info.fifth);
        setNormal(info.normal);
        setReduce(info.reduce);
        setMedical(info.medical);
        setBasic(info.basic);
        setM30(info.M30);
        setM60(info.M60);
        setM90(info.M90);
        setM120(info.M120);
        setM150(info.M150);
        setM180(info.M180);
        setM210(info.M210);
        setM240(info.M240);
      })
      .catch((error) => {
        alert(error);
      });
  }, []);

  const handleRevise = () => {
    const patchChargeAPI = process.env.REACT_APP_SERVER_URI + "/charge";

    // Create an object to store the fields that have changed
    const updatedFields: any = {};

    // Compare and add fields to the updatedFields object
    if (chargeInfo === null || first !== chargeInfo.first) {
      updatedFields.first = first;
    }
    if (chargeInfo === null || second !== chargeInfo.second) {
      updatedFields.second = second;
    }
    if (chargeInfo === null || third !== chargeInfo.third) {
      updatedFields.third = third;
    }
    if (chargeInfo === null || fourth !== chargeInfo.fourth) {
      updatedFields.fourth = fourth;
    }
    if (chargeInfo === null || fifth !== chargeInfo.fifth) {
      updatedFields.fifth = fifth;
    }
    if (chargeInfo === null || normal !== chargeInfo.normal) {
      updatedFields.normal = normal;
    }
    if (chargeInfo === null || reduce !== chargeInfo.reduce) {
      updatedFields.reduce = reduce;
    }
    if (chargeInfo === null || medical !== chargeInfo.medical) {
      updatedFields.medical = medical;
    }
    if (chargeInfo === null || basic !== chargeInfo.basic) {
      updatedFields.basic = basic;
    }
    if (chargeInfo === null || M30 !== chargeInfo.M30) {
      updatedFields.M30 = M30;
    }
    if (chargeInfo === null || M60 !== chargeInfo.M60) {
      updatedFields.M60 = M60;
    }
    if (chargeInfo === null || M90 !== chargeInfo.M90) {
      updatedFields.M90 = M90;
    }
    if (chargeInfo === null || M120 !== chargeInfo.M120) {
      updatedFields.M120 = M120;
    }
    if (chargeInfo === null || M150 !== chargeInfo.M150) {
      updatedFields.M150 = M150;
    }
    if (chargeInfo === null || M180 !== chargeInfo.M180) {
      updatedFields.M180 = M180;
    }
    if (chargeInfo === null || M210 !== chargeInfo.M210) {
      updatedFields.M210 = M210;
    }
    if (chargeInfo === null || M240 !== chargeInfo.M240) {
      updatedFields.M240 = M240;
    }

    if (!_.isEmpty(updatedFields)) {
      setIsLoading(true);
      axios({
        method: "patch",
        url: patchChargeAPI,
        headers: {
          "Content-Type": "application/json",
          Authorization: cookie.admin,
        },
        data: updatedFields,
      })
        .then((res) => {
          console.log("Patch request successful", res);
          return navigate("/charge/table");
        })
        .catch((error) => {
          console.error("Error in patch request", error);
          alert(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      alert("변경된 사항이 없습니다.");
    }
  };

  const revise_btn = (
    <span>
      <button className="revise_btn" onClick={handleRevise}>
        저장
      </button>
    </span>
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;
    switch (id) {
      case "first":
        setFirst(Number(value));
        break;
      case "second":
        setSecond(Number(value));
        break;
      case "third":
        setThird(Number(value));
        break;
      case "fourth":
        setFourth(Number(value));
        break;
      case "fifth":
        setFifth(Number(value));
        break;
      case "normal":
        setNormal(Number(value));
        break;
      case "reduce":
        setReduce(Number(value));
        break;
      case "medical":
        setMedical(Number(value));
        break;
      case "basic":
        setBasic(Number(value));
        break;
      case "M30":
        setM30(Number(value));
        break;
      case "M60":
        setM60(Number(value));
        break;
      case "M90":
        setM90(Number(value));
        break;
      case "M120":
        setM120(Number(value));
        break;
      case "M150":
        setM150(Number(value));
        break;
      case "M180":
        setM180(Number(value));
        break;
      case "M210":
        setM210(Number(value));
        break;
      case "M240":
        setM240(Number(value));
        break;
    }
  };

  return (
    <div className="charge_container">
      <div className="limit_container">
        <table className="charge_table" id="limit">
          <caption id="limit_title">
            장기요양 등급별 월 한도액 및 본인부담률
          </caption>
          <thead>
            <tr>
              <th>장기요양등급</th>
              <th>1등급</th>
              <th>2등급</th>
              <th>3등급</th>
              <th>4등급</th>
              <th>5등급</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>월 한도액 (원)</th>
              <td>
                <input
                  id="first"
                  type="number"
                  value={first}
                  onChange={handleChange}
                ></input>
              </td>
              <td>
                <input
                  id="second"
                  type="number"
                  value={second}
                  onChange={handleChange}
                ></input>
              </td>
              <td>
                <input
                  id="third"
                  type="number"
                  value={third}
                  onChange={handleChange}
                ></input>
              </td>
              <td>
                <input
                  id="fourth"
                  type="number"
                  value={fourth}
                  onChange={handleChange}
                ></input>
              </td>
              <td>
                <input
                  id="fifth"
                  type="number"
                  value={fifth}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
          </tbody>
          <thead className="responsive">
            <th>대상</th>
            <th>일반대상자</th>
            <th>경감대상자</th>
            <th>의료대상자</th>
            <th>기초생활수급권자</th>
          </thead>
          <tbody className="responsive">
            <tr>
              <th>본인부담율(%)</th>
              <td>
                <input
                  id="normal"
                  type="number"
                  value={normal}
                  onChange={handleChange}
                ></input>
              </td>
              <td>
                <input
                  id="reduce"
                  type="number"
                  value={reduce}
                  onChange={handleChange}
                ></input>
              </td>
              <td>
                <input
                  id="medical"
                  type="number"
                  value={medical}
                  onChange={handleChange}
                ></input>
              </td>
              <td>
                <input
                  id="basic"
                  type="number"
                  value={basic}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="pay_container">
        <table className="charge_table" id="pay">
          <caption id="pay_title">방문요양 서비스의 급여비용 산정기준</caption>
          <thead>
            <tr>
              <th>분류</th>
              <th>금액 (원)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>30분 이상</td>
              <td>
                <input
                  id="M30"
                  type="number"
                  value={M30}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
            <tr>
              <td>60분 이상</td>
              <td>
                <input
                  id="M60"
                  type="number"
                  value={M60}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
            <tr>
              <td>90분 이상</td>
              <td>
                <input
                  id="M90"
                  type="number"
                  value={M90}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
            <tr>
              <td>120분 이상</td>
              <td>
                <input
                  id="M120"
                  type="number"
                  value={M120}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
            <tr>
              <td>150분 이상</td>
              <td>
                <input
                  id="M150"
                  type="number"
                  value={M150}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
            <tr>
              <td>180분 이상</td>
              <td>
                <input
                  id="M180"
                  type="number"
                  value={M180}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
            <tr>
              <td>210분 이상</td>
              <td>
                <input
                  id="M210"
                  type="number"
                  value={M210}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
            <tr>
              <td>240분 이상</td>
              <td>
                <input
                  id="M240"
                  type="number"
                  value={M240}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {revise_btn}
      <LoaderOverlay open={isLoading} text="처리 중입니다" />
    </div>
  );
}

export default ReviseChargePage;
